import React from 'react';
import { Card, CardContent, Box, Typography, LinearProgress, Avatar } from '@mui/material';
import { People as PeopleIcon } from '@mui/icons-material';

const ClientsCard = ({ data, goal }) => {
  const active = data?.active || 0;
  const progress = Math.min((active / goal) * 100, 100);

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 1.5 }}>
          <Avatar
            sx={{
              bgcolor: 'success.light',
              color: 'success.dark',
              width: 36,
              height: 36,
            }}
          >
            <PeopleIcon sx={{ fontSize: 20 }} />
          </Avatar>
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', fontSize: '0.7rem' }}>
              Active Clients
            </Typography>
            <Typography variant="h5" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
              {active}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mb: 1 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
              Goal: {goal} clients
            </Typography>
            <Typography variant="caption" fontWeight={600} color="success.main" sx={{ fontSize: '0.75rem' }}>
              {progress.toFixed(0)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={progress}
            color="success"
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: 'grey.100',
            }}
          />
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
          {goal - active} more clients to reach your goal
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ClientsCard;
